import { render, staticRenderFns } from "./SaveAndClosedModal.vue?vue&type=template&id=5f0c4dc8&scoped=true&"
import script from "./SaveAndClosedModal.vue?vue&type=script&lang=js&"
export * from "./SaveAndClosedModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveAndClosedModal.vue?vue&type=style&index=0&id=5f0c4dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0c4dc8",
  null
  
)

export default component.exports